/*
 *  Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { EstatePeriod, Granularity } from "~/components";
import { useQueryState } from "~/hooks";
import {
  getEndDate,
  getStartDate,
  EstateRecordsCostPerOrgUnit,
} from "~/views/estate/components/Charts";
import { EstateChartsQueryState } from "./components";

type Props = {
  period: EstatePeriod;
  granularity: Granularity;
};

export function EstateRecordsOrgUnitView({ period, granularity }: Props) {
  const {
    state: { periodStart, periodEnd },
  } = useQueryState<EstateChartsQueryState>();

  const startDate =
    periodStart ?? getStartDate(EstatePeriod.CURRENT_MONTH, undefined);
  const endDate =
    periodEnd ?? getEndDate(EstatePeriod.CURRENT_MONTH, undefined);

  return (
    <EstateRecordsCostPerOrgUnit
      granularity={granularity}
      startDate={startDate}
      endDate={endDate}
      period={period}
    />
  );
}
